module.exports = __webpack_public_path__ + "static/qr-code-open-account-kids-modal-293eb4aa8105a10ebc31c7262d1affc0.png";